import { Role } from '@account/../../models/account/role.model';
import { Injectable } from '@angular/core';
import { BaseResolver } from '@app/app.resolver';
import { ModelFactory } from '@app/models/core/model-factory';
import { DataFieldGroup } from '@app/models/settings/data-field-group.model';
import { DataField } from '@settings/../../models/settings/data-field.model';

@Injectable()
export class SettingsResolver extends BaseResolver {
    protected modelFactory: ModelFactory = new ModelFactory([
        {
            className: 'field',
            production: {
                find: (id: number) => {
                    return DataField.param('company', this.companyId)
                        .with([
                            'dataFieldGroup',
                            'dataFieldOptions',
                            'roles',
                            'viewOnlyRoles',
                            'employees',
                            'employees.account',
                        ])
                        .find(id);
                },
            },
        },
        {
            className: 'fieldGroup',
            production: {
                find: (id: number) => {
                    return DataFieldGroup.param('company', this.companyId).find(id);
                },
            },
        },
        {
            className: 'role',
            production: {
                find: (id: number) => {
                    return Role.param('company', this.companyId)
                        .with(['permissions', 'roleAssignments.account.employee'])
                        .find(id);
                },
            },
        },
    ]);
}
